/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Limit_1_ValueInputs */

const en_svc_agents_limit_1_value = /** @type {(inputs: Svc_Agents_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything that leaves the business can wait for a person to approve it.`)
};

const lv_svc_agents_limit_1_value = /** @type {(inputs: Svc_Agents_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viss, kas iziet no uzņēmuma, var gaidīt cilvēka apstiprinājumu.`)
};

/**
* | output |
* | --- |
* | "Anything that leaves the business can wait for a person to approve it." |
*
* @param {Svc_Agents_Limit_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_limit_1_value = /** @type {((inputs?: Svc_Agents_Limit_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Limit_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_limit_1_value(inputs)
	return en_svc_agents_limit_1_value(inputs)
});